import script from "./CreateCompleteTimeRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCompleteTimeRecord.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__